// extracted by mini-css-extract-plugin
export default {"customLayoutWrapper":"CustomLayoutView_customLayoutWrapper__X6OhE"};